import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isTextArea(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.TEXT_AREA && typeof label === 'string' && typeof value === 'string';
}
function _formatTextArea(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatTextArea(submission) {
  if (isTextArea(submission)) {
    return _formatTextArea(submission);
  }
  return undefined;
}
//# sourceMappingURL=text-area-preview.js.map